import React from 'react';
import PropTypes from 'prop-types';

export default class TextAreaInput extends React.Component {

    render() {
        let inputClasses = '';
        if (this.props.required) {
            inputClasses += ' required';
        }
        if (this.props.error && this.props.error !== '') {
            inputClasses += ' error';
        }
        else if (this.props.warning && this.props.warning !== '') {
            inputClasses += ' warning';
        }
        
        if (this.props.type) {
            type = this.props.type;
        }
        return (
            <label>
                <span className="sub-title text--grey">{this.props.label}</span>
                {this.props.tooltip}
                <div className="relative">
                    <textarea name={this.props.name} value={this.props.value} className={inputClasses} onChange={this.props.onChange} required={this.props.required} disabled={this.props.disabled} placeholder={this.props.placeholder} onBlur={this.props.onBlur} onFocus={this.props.onFocus} id={this.props.id}/>
                    <span className="error-indicator"></span>
                    <span className="warning-indicator"></span>
                </div>
                {this.props.error && <span className="error text--red">{this.props.error}</span>}
                {!this.props.error && this.props.warning && <span className="error text--warning">{this.props.warning}</span>}
            </label>
        )
    }
}

TextAreaInput.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string,
    error: PropTypes.string,
    autocomplete: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
};
